import { TableColumn, TableConfig, SORT_ORDER } from "../../../../../../../@shared/models/table.models";

export const REVIEW_CLAUSES_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Clause name",
        type: "text",
        width: "15%",
        sortable: true
    },
    {
        field: "clauseBundles",
        header: "Clause bundle",
        type: "custom",
        template: "clauseBundleTemplate",
        width: "12%"
    },
    {
        field: "source",
        header: "Source",
        type: "custom",
        template: "sourceTemplate",
        width: "13%"
    },
    {
        field: "createdBy",
        header: "Created by",
        type: "custom",
        template: "createdByTemplate",
        width: "13%"
    },
    {
        field: "createdAt",
        header: "Created date",
        type: "custom",
        template: "createdAtTemplate",
        width: "12%"
    },
    {
        field: "confidence",
        header: "Confidence",
        type: "custom",
        template: "confidenceTemplate",
        width: "12%"
    },
    {
        field: "approveOrReject",
        header: "Approve / Reject",
        type: "custom",
        template: "approveOrRejectTemplate",
        width: "13%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "10%"
    }
];

export const REVIEW_CLAUSES_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "calc(100vh - 20rem)",
    loading: false,
    emptyMessage: "No clauses found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { }
};
